import {
  DagMonthResponse,
  DagResponse
} from 'src/app/services/forbruk/forbruk.types';
import { sumNum } from 'src/app/utils/array-utils';

export const getIFjor = (
  res: DagMonthResponse | DagResponse,
  objectId: string
) => {
  const anlegg = res.anlegg.find((x) => x.objectid === objectId);
  const verdierIFjor = anlegg.verdiList.map((x) => x.verdi);
  return sumNum(verdierIFjor);
};

export const getIfjorSnitt = (
  res: DagMonthResponse | DagResponse,
  objectId: string
) => {
  const verdierIFjor = res.anlegg
    .find((x) => x.objectid === objectId)
    .verdiList.map((x) => x.verdi);
  return sumNum(verdierIFjor) / verdierIFjor.length;
};

export const getIfjorHighest = (
  res: DagMonthResponse | DagResponse,
  objectId: string
) => {
  const verdierIFjor = res.anlegg
    .find((x) => x.objectid === objectId)
    .verdiList.map((x) => x.verdi);
  return Math.max(...verdierIFjor);
};

export const getIfjorLowest = (
  res: DagMonthResponse | DagResponse,
  objectId: string
) => {
  const verdierIFjor = res.anlegg
    .find((x) => x.objectid === objectId)
    .verdiList.map((x) => x.verdi);
  return Math.min(...verdierIFjor);
};

export const hasIfjor = (
  res: DagMonthResponse | DagResponse,
  objectId: string
) => {
  const anlegg = res.anlegg.find((x) => x.objectid === objectId);
  return anlegg && anlegg.verdiList.length > 0;
};

export const getIFjorPluss = (
  res: DagMonthResponse | DagResponse,
  objectId: string
) => {
  const verdierIFjor = res.anlegg
    .find((x) => x.objectid === objectId)
    .verdiList.map((x) => x.plussverdi);
  return sumNum(verdierIFjor);
};

export const toRoundNumberHour = (num: number) => {
  return toCommaNumber(num);
};

export const toRoundNumber = (num: number) => {
  return Math.round(num).toLocaleString('nb-NO');
};

export const toCommaNumber = (num: number) => {
  return num.toFixed(2).replace('.', ',');
};

export const capFirst = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const thisPeriod = (selectedDate: Date) => {
  const thisYear = new Date()?.getFullYear();
  if (selectedDate?.getFullYear() === thisYear) {
    return 'i år';
  } else {
    return selectedDate?.getFullYear().toString();
  }
};

export const comparePeriod = (selectedDate: Date) => {
  const lastYear = new Date()?.getFullYear() - 1;
  if (selectedDate?.getFullYear() - 1 === lastYear) {
    return 'i fjor';
  } else {
    return (selectedDate?.getFullYear() - 1).toString();
  }
};
